{
  "login-secret-with-password-page": {
    "buttons": {
      "forgot-password": "Quên mật khẩu",
      "login": "Đăng nhập",
      "set-password": "Đặt mật khẩu",
      "update-password": "Cập nhật mật khẩu"
    },
    "text": {
      "new-password": "Đặt mật khẩu của bạn",
      "new-password-hint": "Mật khẩu của bạn sẽ được yêu cầu cho những lần đăng nhập tiếp theo",
      "password": "Mật khẩu",
      "password-invalid": "Mật khẩu của bạn là không chính xác. Vui lòng thử lại!",
      "password-hint": "Vui lòng nhập mật khẩu của bạn để đăng nhập",
      "update-password": "Mật khẩu mới",
      "update-password-hint": "Vui lòng nhập mật khẩu mới của bạn",
      "your-password": "Mật khẩu của bạn"
    }
  }
}
